import DoorReport from './DoorReport';

function App() {
  return <DoorReport />;
}

export default App;